/**
 * /app/profile — Account & profile (route shell, TRUSTEE-05).
 *
 * Screen impl in `./profile-screen.tsx`, lazy-loaded to keep this secondary
 * trustee surface out of the dashboard-first initial payload.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/app/profile')({
  component: lazyRouteComponent(() => import('./profile-screen'), 'ProfileScreen'),
});
